import { chakra, forwardRef, useStyleConfig } from '@chakra-ui/react';
import React, { ComponentPropsWithoutRef } from 'react';

import { Kbd } from '../Kbd/Kbd';

export interface KbdComboProps extends ComponentPropsWithoutRef<'kbd'> {
  className?: string;
  modifier?: '+' | 'or';
  keys: string[];
}

export const KbdCombo = forwardRef<KbdComboProps, 'kbd'>(
  ({ keys, className, modifier = '+', ...props }, ref) => {
    const styles = useStyleConfig('KbdCombo');

    return (
      <chakra.kbd {...props} ref={ref} className={className} __css={styles}>
        {keys.map((key, idx) => (
          <React.Fragment key={key}>
            <Kbd text={key} />
            {idx !== keys.length - 1 && modifier}
          </React.Fragment>
        ))}
      </chakra.kbd>
    );
  },
);
